
import React, { ReactNode } from 'react';
import { Icons } from './Icons';

interface ModalProps {
    title: string;
    children: ReactNode;
    onClose: () => void;
    maxWidthClass?: string;
}

const Modal: React.FC<ModalProps> = ({ title, children, onClose, maxWidthClass = 'sm:max-w-2xl' }) => {
    return (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 dark:bg-black/80 transition-opacity z-50 flex justify-center items-start py-10 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="fixed inset-0" onClick={onClose} aria-hidden="true"></div>
            <div className={`relative bg-white dark:bg-slate-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 ${maxWidthClass} sm:w-full`}>
                <div className="bg-white dark:bg-slate-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-2">
                    <div className="flex items-start justify-between">
                        <h3 className="text-lg leading-6 font-medium text-gray-900 dark:text-gray-100" id="modal-title">
                            {title}
                        </h3>
                         <button 
                            type="button"
                            onClick={onClose} 
                            className="p-1 rounded-full text-gray-400 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-slate-700 hover:text-gray-600 dark:hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            aria-label="Close modal"
                        >
                           <Icons.X className="w-5 h-5"/>
                        </button>
                    </div>
                </div>
                {children}
            </div>
        </div>
    );
};

export default Modal;